var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSelectOffice2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 2520,
    height: 1700,
    viewBox: "0 0 2520 1700",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: 2,
    d: "M1444.5 1077.42H1202.38V1267.51H1127.5V1354.19V1395H1359L1444.5 1307V1077.42Z",
    fill: "#FFD426",
    fillOpacity: 0.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: 1,
    d: "M1294 718L1296.5 624.5H1211V562.5H1160.5V543.663V206.5H799.395H715V528.457V593.339V629.835H1066.53V718H1294Z",
    fill: "#FFD426",
    fillOpacity: 0.2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: 3,
    d: "M1525.5 206V324.5H1531L1532.5 447.86H1876.04V543.663H2382.5V206H1970.32H1936.36H1525.5Z",
    fill: "#FFD426",
    fillOpacity: 0.2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: 4,
    d: "M2382.5 543.663V957.5H2157.36V846.786H2063.59V783.931H1938.5V543.663H1970.83H2382.5Z",
    fill: "#FFD426",
    fillOpacity: 0.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelectOffice2);
export default __webpack_public_path__ + "static/media/select-office-2.1aa62757.svg";
export { ForwardRef as ReactComponent };